module.exports = __webpack_public_path__ + "static/img/pMRI5.3e9189da.png";